import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { InputX } from 'components'
import styles from './index.module.css'

const CareerCompanySearch = () => {

	const App = useApp()
	const [tabMenu, setTabMenu] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="padding pb_0">
					<ul className="tab-round-box">
						<li onClick={() => setTabMenu(0)} className={tabMenu === 0 ? "on" : ""}>회사명</li>
						<li onClick={() => setTabMenu(1)} className={tabMenu === 1 ? "on" : ""}>사업자 등록번호</li>
					</ul>
					<div className="form-group search-bar mt_30">
						<InputX type="text" defaultValue="주식회사 모니" id="" />
						<i className="icon icon_search" />
					</div>
					<p className={`${styles["search-result"]} mt_40`}>
						<span>4</span>개 회사정보를 검색했어요!
					</p>
				</div>
				<ul className={`${styles["career-list"]} list-bg`}>
					<li>
						<div>
							<div className={styles.title}>주식회사 모니
								<span className={`${styles["company-num"]}`}>(113-86-5****)</span>
							</div>
							<p className={styles.address}>서울 영등포구 여의대로 24, 43층</p>
						</div>
						<i className="icon icon_arrow_sm right ml_20" />
					</li>
					<li>
						<div>
							<div className={styles.title}>주식회사 모니
								<span className={`${styles["company-num"]}`}>(113-86-5****)</span>
							</div>
							<p className={styles.address}>서울 영등포구 여의대로 24, 43층</p>
						</div>
						<i className="icon icon_arrow_sm right ml_20" />
					</li>
					<li>
						<div>
							<div className={styles.title}>주식회사 모니
								<span className={`${styles["company-num"]}`}>(113-86-5****)</span>
							</div>
							<p className={styles.address}>서울 영등포구 여의대로 24, 43층</p>
						</div>
						<i className="icon icon_arrow_sm right ml_20" />
					</li>
					<li>
						<div>
							<div className={styles.title}>주식회사 모니
								<span className={`${styles["company-num"]}`}>(113-86-5****)</span>
							</div>
							<p className={styles.address}>서울 영등포구 여의대로 24, 43층</p>
						</div>
						<i className="icon icon_arrow_sm right ml_20" />
					</li>
				</ul>
			</div>
			<div className="flex-shrink_0 padding">
				<div className="text-align_center" style={{ color: "#999", lineHeight: "2rem" }}>
					원하는 회사정보가 나오지 않는다면<br />
					사업자 등록번호로 검색해보세요!
				</div>
			</div>
		</div>
	)
}

export default CareerCompanySearch
